import { configureStore, getDefaultMiddleware } from '@reduxjs/toolkit';
import reducer from "./reducer";
import api from "./middleware/api";
import { apiSlice } from "./apiSlice";
import { rtkQueryErrorLogger } from "./middleware/errorLogger";
//import { persistStore, persistReducer } from 'redux-persist'
// import storage from 'redux-persist/lib/storage' // defaults to localStorage for web

// const persistConfig = {
//   key: 'root',
//   storage,
// }

// const persistedReducer = persistReducer(persistConfig, reducer)

const store = configureStore({
  reducer: reducer,
   middleware: [
    ...getDefaultMiddleware({
      serializableCheck: false,
    }),
    api,
    apiSlice.middleware,
    rtkQueryErrorLogger,
  ]
});
//export const persistor = persistStore(store)
export default store;


